import { useState } from "react";

import "./styles/App.css";
import CellGrid from "./CellGrid";
import Intro from "./Intro";
import { PagesEnum, cellData } from "./utils";
import PrintAndSign from "./PrintAndSign";
import SingleCell from "./SingleCell";

function App() {
  const [page, setPage] = useState(PagesEnum.INTRO);
  const [cell, setCell] = useState(null);
  const [printColors, setPrintColors] = useState(null);

  const resetLayerColors = (cellNum) => {
    // reset layer colors to white
    const tempCellInfo = cellData[cellNum];
    const tempLayerColors = {};
    for (let i = 1; i <= tempCellInfo.layers.length; i++) {
      tempLayerColors[i] = "white";
    }
    setPrintColors(tempLayerColors);
  };

  const selectCell = (cellNumber) => {
    if (cellNumber > 0 && cellNumber < 10) {
      setCell(cellNumber);
      resetLayerColors(cellNumber);
      setPage(PagesEnum.SINGLE);
    }
  };

  const setPrintColorsFromEditor = (colors) => {
    setPage(PagesEnum.PRINT);
    setPrintColors(colors);
  };

  return (
    <div className="App">
      {page === PagesEnum.INTRO && <Intro setPage={setPage} />}
      {page === PagesEnum.GRID && <CellGrid selectCell={selectCell} />}
      {page === PagesEnum.SINGLE && cell && (
        <SingleCell
          cell={cell}
          setPage={setPage}
          resetColors={resetLayerColors}
          setColors={setPrintColors}
          colors={printColors}
          setPrintColors={setPrintColorsFromEditor}
        />
      )}
      {page === PagesEnum.PRINT && cell && printColors && (
        <PrintAndSign
          cell={cell}
          setPage={setPage}
          printColors={printColors}
          setPrintColors={setPrintColors}
        />
      )}
    </div>
  );
}

export default App;
